import { render, staticRenderFns } from "./listRelated.vue?vue&type=template&id=454530cc&"
import script from "./listRelated.vue?vue&type=script&lang=js&"
export * from "./listRelated.vue?vue&type=script&lang=js&"
import style0 from "./listRelated.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports